export const SHIPPING_COMPANY = {
  CJ: 'cj',
  DOORA: 'doora',
  EMS: 'ems',
  DHL: 'dhl',
  LOTTELOGI: 'lotte',
};
